import React from "react";

function Video(props) {
  return (
    <div className="col-md-12 nopadding border-1">
    <video controls >
        <source src={props.src} type={'video/mp4'}></source>
    </video>
    </div>
  );
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Common/Video.js